/**
 * Professional Logger Utility
 * Only logs in development mode to prevent sensitive data leakage in production
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LoggerConfig {
  enabled: boolean;
  level: LogLevel;
}

const config: LoggerConfig = {
  enabled: import.meta.env.DEV,
  level: 'debug',
};

const levelPriority: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

class Logger {
  private shouldLog(level: LogLevel): boolean {
    if (!config.enabled) return false;
    return levelPriority[level] >= levelPriority[config.level];
  }

  debug(...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.log('[DEBUG]', ...args);
    }
  }

  info(...args: any[]): void {
    if (this.shouldLog('info')) {
      console.info('[INFO]', ...args);
    }
  }

  warn(...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn('[WARN]', ...args);
    }
  }

  error(...args: any[]): void {
    if (this.shouldLog('error')) {
      console.error('[ERROR]', ...args);
    }
  }

  // Utility per logging di oggetti sensibili
  sensitive(label: string, data: any): void {
    if (this.shouldLog('debug')) {
      console.log(`[SENSITIVE] ${label}:`, '***REDACTED IN PROD***');
    }
  }
}

export const logger = new Logger();
